import { AxiosError } from 'axios';
import AlertModal from 'components/common/AlertModal';
import { StatusCodes } from 'http-status-codes';
import { CommonResponse } from 'models';
import i18n from 'translation/i18n';
import { ERROR_NOTIFICATION_CODES } from './constants';

export function handleServiceError(showGlobalModal: (component: React.ElementType) => void, error?: AxiosError) {
  const { t } = i18n;

  if (ERROR_NOTIFICATION_CODES.includes(Number(error?.response?.status))) {
    showGlobalModal(() => <AlertModal title={t('App.error')} message={t('App.unexpected_error')} />);
    return true;
  }

  if (error && error.response?.status === StatusCodes.UNAUTHORIZED) {
    return true;
  }

  return false;
}

export function displayError(
  showGlobalModal: (component: React.ElementType) => void,
  error: AxiosError,
  onClose?: () => void
) {
  const { t } = i18n;

  const errorData = error.response?.data as CommonResponse<any>;
  if (errorData) {
    if (!errorData.data) {
      showGlobalModal(() => <AlertModal title={t('App.error')} message={errorData.message} onClose={onClose} />);
    } else {
      const errorResponse = (error as AxiosError).response?.data as CommonResponse<any>;
      let errorMessage = '';
      for (const property in errorResponse.data.errors) {
        if (Array.isArray(errorResponse.data.errors[property])) {
          errorMessage += errorResponse.data.errors[property].join('<br />');
        } else {
          errorMessage += errorResponse.data.errors[property];
        }
        errorMessage += '<br />';
      }

      if (errorMessage.length > 0) {
        showGlobalModal(() => <AlertModal title={t('App.error')} message={errorMessage} onClose={onClose} />);
      }
    }
  }
}
